//scss
import "../scss/apply-splash.scss";

//Global elements
import "./js-reusable/header"
import "./js-reusable/gdpr"
import "./js-reusable/footer"

//imported logic goes here
import navBarFunc from "./js-comps/navbar";
import translatorFunc from "./js-comps/translator";
import gdprFunctionality from "./js-comps/gdpr";

navBarFunc();
translatorFunc();
gdprFunctionality();
